<div class="dialog-wrapper">
    <div class="header">
        <p>
            {{
                injectedData.headerTranslationKey
                    | translate: injectedData.headerInterpolateParameters
            }}
        </p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="input-form">
        <div class="field" *ngFor="let field of injectedData.fields">
            <label
                [for]="field.controlName"
                [id]="field.controlName + '-label'"
            >
                {{
                    (field.labelTranslationKey | translate) +
                        (isFieldRequired(field) ? '*' : '')
                }}
            </label>
            <input
                *ngIf="isTextField(field)"
                [id]="field.controlName"
                [formControl]="getControl(field.controlName)"
                type="text"
                [class.is-invalid]="
                    getControl(field.controlName).invalid &&
                    getControl(field.controlName).touched
                "
                [maxlength]="field.maxLength ?? 50"
                (focusout)="onFieldLeave(field.controlName)"
            />
            <div class="select-container" *ngIf="isSelectField(field)">
                <select
                    [id]="field.controlName"
                    [formControl]="getControl(field.controlName)"
                    [class.is-invalid]="
                        getControl(field.controlName).invalid &&
                        getControl(field.controlName).touched
                    "
                >
                    <option
                        *ngFor="let option of field.options ?? []"
                        [value]="option.value"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <p class="field-info" *ngIf="field.infoTranslationKey">
                {{ field.infoTranslationKey | translate }}
            </p>
            <div
                class="error-div"
                *ngIf="
                    !getControl(field.controlName).pristine &&
                    getControl(field.controlName).invalid
                "
            >
                <app-display-errors
                    [control]="getControl(field.controlName)"
                    [translationKey]="
                        injectedData.inputErrorTranslationKeyPrefix ??
                        'default.validation.errors'
                    "
                ></app-display-errors>
            </div>
        </div>

        <p class="submit-error" *ngIf="submitErrorTranslationKey">
            {{ submitErrorTranslationKey | translate }}
        </p>

        <div class="action-buttons">
            <button
                type="submit"
                class="confirm-button"
                [disabled]="form.invalid || isSubmitting"
            >
                {{ injectedData.submitButtonTranslationKey | translate }}
            </button>
            <button
                *ngIf="injectedData.cancelButtonTranslationKey"
                type="button"
                class="cancel-button"
                [disabled]="isSubmitting"
                (click)="onCancel()"
            >
                {{ injectedData.cancelButtonTranslationKey | translate }}
            </button>
        </div>
    </form>
</div>
